import * as React from "react";
import { FieldValueYesNo } from "typings";
import { Toggle  } from "office-ui-fabric-react/lib/Toggle";
import { BaseFieldEditor } from "./helper";

export interface Props extends BaseFieldEditor
{
    value: FieldValueYesNo;
}

interface State
{
    
}

class YesNo extends React.Component<Props, State>
{
    
    onValueChange = () =>
    {
        const value = this.props.value && this.props.value.value ? this.props.value.value : false;

        const fieldValue: FieldValueYesNo = {...this.props.value, value: !value};
        this.props.onValueChange(fieldValue);
    }

    render()
    {
        const value = this.props.value && this.props.value.value ? this.props.value.value : false;
        return <div>
            <Toggle disabled={this.props.disabled} onChange={this.onValueChange} checked={value}></Toggle>
        </div>;
    }
}

export default YesNo;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/YesNo.tsx